import React from 'react';
import css from './index.scss';

const PulseLoader = () => (
  <div className={css.pulseLoader}>
    <div /><div /><div /><div />
  </div>
);


export default PulseLoader;



// WEBPACK FOOTER //
// ./components/pulse-loader/index.js